import store from '@/store'
import config from '@/config'
import utils from '../../common/utils'
import Lite from './lite'
import Verify from './verify'
import xpjsService from '@/library/geolocation/services/providers/xpoint/xpjsService'

const isDebug = sessionStorage.geolocationDebug
const GEOLOCATION_CONFIG = config.app.autoconf.GEOLOCATION
const CLIENT_KEY = GEOLOCATION_CONFIG && GEOLOCATION_CONFIG.XPOINT && GEOLOCATION_CONFIG.XPOINT.CLIENT_KEY
const SOLUTION = GEOLOCATION_CONFIG && GEOLOCATION_CONFIG.XPOINT && GEOLOCATION_CONFIG.XPOINT.SOLUTION
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

const solutions = {
  Lite,
  Verify
}
const activeSolution = solutions[SOLUTION]

async function startGeolocation (user, sessionId, reason = 'Login') {
  if (reason === 'Login') {
    localStorage.geolocationOnLogin = true
    utils.showSpinnerOnStart()
  }
  if (!activeSolution) throw new Error(`Unknown solution: ${SOLUTION}`)
  let allValid = await activeSolution.checkPermissionOrPlugin(user, sessionId, reason)
  if (!allValid) {
    let msg = SOLUTION === 'Lite' ? 'No browser permissions.' : 'Verify app is not active or not installed.'
    if (isDebug) console.log(`[XPoint] ${msg}`)
    return false
  }

  if (isDebug && reason === 'Login') console.log('[XPoint] Solution in use:', SOLUTION)
  await sleep(3000)
  activeSolution.checkStatus(user, sessionId, reason, CLIENT_KEY)
}

function validateResponse (result, userID) {
  store.commit('setOnLoginGeolocationProgress', 'validate_geo_response')
  sessionStorage.removeItem('tempPromotionSection')
  if (result.IsValid) {
    locationVerified(result, userID)
  }
  if (!result.IsValid) {
    locationFailed(result, userID)
    store.commit('setGeocomplyTroubleshooter', result.Troubleshooter)
  }
}

/** --------------------------------
 *  location verified ; allow user to place bet, remove error messages
 -------------------------------- **/
async function locationVerified (result) {
  store.commit('setOnLoginGeolocationProgress', 'completed')
  if (isDebug) console.log('[XPoint] Location is verified.')
  localStorage.removeItem('tgc')
  localStorage.setItem('gcPerm', true)
  store.commit('setGeolocated', true)
  const options = {
    userId: localStorage.customer || false,
    client: CLIENT_KEY
  }
  let isSubscribed = await xpjsService.getSubscription()
  if (isSubscribed === null) activeSolution.startStatusUpdate(options, result)
  setTimeout(() => {
    if (localStorage.geolocationOnLogin) {
      store.dispatch('triggerBSLocationVerifiedAnimation', true)
      localStorage.removeItem('geolocationOnLogin')
    }
  }, 100)
  localStorage.setItem('geoError', false)
  setTimeout(() => {
    store.commit('setGeolocationOnLogin', false)
  }, 6000)
}

async function continueGeolocationProcess () {
  let user = localStorage.customer
  let allValid = await activeSolution.checkPermissionOrPlugin(user, false, 'Login')
  if (!allValid) {
    return false
  }
  if (isDebug) console.log(`[XPoint] Continue ${SOLUTION} after reload.`)
  if (!activeSolution) {
    throw new Error(`Unknown solution: ${SOLUTION}`)
  }
  let isAttemptIdReady = await utils.requestAttemptId()
  if (isAttemptIdReady) {
    activeSolution.checkStatus(user, false, 'Reload', CLIENT_KEY)
  }
}

/** --------------------------------
 * location failed ; remove permission, display errors
 -------------------------------- **/
function locationFailed (response, userID) {
  if (isDebug) console.log('[XPoint] Location not verified.', response.Troubleshooter)
  store.commit('setOnLoginGeolocationProgress', 'completed')
  localStorage.removeItem('geolocationOnLogin')
  store.commit('setGeolocationOnLogin', false)
  localStorage.setItem('gcMessages', JSON.stringify(response.Troubleshooter))
  let errorCode = 999
  utils.displayErrorMessage(errorCode, response.Troubleshooter, userID)
  utils.resetGeolocationState()
  disconnectService(true)
}

function disconnectService (forceAll = false) {
  if (!activeSolution) {
    throw new Error(`Unknown solution: ${SOLUTION}`)
  }
  activeSolution.disconnectService(forceAll)
}

function downloadPlugin () {
  if (!activeSolution) {
    throw new Error(`Unknown solution: ${SOLUTION}`)
  }
  activeSolution.download()
}

/**
 * Checks whether a given XPoint response contains error code 5010.
 * Code 5010 indicates that the user's session has expired and must be refreshed.
 */
function has5010Error (checkRequest) {
  if (!checkRequest || !Array.isArray(checkRequest.errors)) return false
  return checkRequest.errors.some(err => err.code === 5010)
}

export default {
  startGeolocation,
  downloadPlugin,
  validateResponse,
  disconnectService,
  continueGeolocationProcess,
  has5010Error
}



// WEBPACK FOOTER //
// ./src/library/geolocation/services/providers/xpoint/helpers.js